// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3IJct","legacyBtn":"MutateMid_legacyBtn__nJ_MR"};